<div class="img-container cursor-pointer" *ngIf="fileUrl">
  <img [src]="fileUrl" alt="preview_img" [swal]="{ title: 'Etiqueta', html: imgEl, confirmButtonText: 'Cerrar' }">
</div>